<template>
  <div>
    <template v-if="$store.state.Auth.status === 'logged'">
      <v-list-item
        to="/travel-service"
        v-if="
          $store.getters['userProperties'].system_settings.is_module_travel_service_enabled === 2 &&
            ($store.getters.hasPermission('travelOrder') || $store.getters.hasPermission('travelOrderSelf'))
        "
      >
        <v-list-item-action>
          <v-icon>format_list_numbered</v-icon>
        </v-list-item-action>
        <v-list-item-content>{{ $t("global.menu.travelOrders") }}</v-list-item-content>
      </v-list-item>
      <v-list-item v-if="hasPermissionForBookings" to="/booking">
        <v-list-item-action>
          <v-icon>event</v-icon>
        </v-list-item-action>
        <v-list-item-content>{{ $t("global.menu.bookings") }}</v-list-item-content>
      </v-list-item>
      <v-list-item
        to="/delegation"
        v-if="$store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2"
        :class="{
          'v-list-item--active': $route.fullPath.includes('delegation') && !$route.fullPath.includes('delegation-info') && !$route.fullPath.includes('settings')
        }"
      >
        <v-list-item-action>
          <v-icon>assignment</v-icon>
        </v-list-item-action>
        <v-list-item-content>{{ $t("global.menu.delegations") }}</v-list-item-content>
      </v-list-item>

      <v-list-item v-if="hasPermissionForAdmin" to="/settings/users" :class="{ 'v-list-item--active': $route.fullPath.includes('/settings/') }">
        <v-list-item-action>
          <v-icon>settings</v-icon>
        </v-list-item-action>
        <v-list-item-content>{{ $t("global.menu.administration") }}</v-list-item-content>
      </v-list-item>

      <v-list-item v-if="hasPermissionForInvoices" to="/invoices">
        <v-list-item-action>
          <v-icon>content_copy</v-icon>
        </v-list-item-action>
        <v-list-item-content>{{ $t("global.menu.invoices") }}</v-list-item-content>
      </v-list-item>

      <v-list-item
        to="/report"
        :disabled="!$store.getters.hasPermission('reportDelegation')"
        v-if="$store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2"
      >
        <v-list-item-action>
          <v-icon>show_chart</v-icon>
        </v-list-item-action>
        <v-list-item-content>{{ $t("global.menu.reports") }}</v-list-item-content>
      </v-list-item>

      <v-list-item
        to="/optima"
        :disabled="!$store.getters.hasPermission('reportDelegation')"
        v-if="
          $store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2 &&
            $store.getters['userProperties'].system_settings.is_module_optima_enabled === 2
        "
      >
        <v-list-item-action>
          <v-icon>extension</v-icon>
        </v-list-item-action>
        <v-list-item-content>{{ $t("global.menu.optima") }}</v-list-item-content>
      </v-list-item>

      <v-list-item to="/delegation-info" v-if="$store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2">
        <v-list-item-action>
          <v-icon>view_agenda</v-icon>
        </v-list-item-action>
        <v-list-item-content>{{ $t("global.menu.delegationInfo") }}</v-list-item-content>
      </v-list-item>
      <v-list-item to="/profile/my-profile">
        <v-list-item-action>
          <v-icon>person_outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>{{ $t("global.menu.profileSettings") }}</v-list-item-content>
      </v-list-item>
      <v-list-item
        to="/substitutes"
        v-if="
          $store.getters['userProperties'].system_settings.is_module_travel_service_enabled === 2 ||
            $store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2
        "
      >
        <v-list-item-action>
          <v-badge color="primary" class="menu-badge" :value="countCanLoginAs != null && countCanLoginAs !== 0">
            <span slot="badge">{{ countCanLoginAs }}</span>
            <v-icon>people_outline</v-icon>
          </v-badge>
        </v-list-item-action>
        <v-list-item-content>{{ $t("global.menu.userSubstitute") }}</v-list-item-content>
      </v-list-item>

      <v-list-item @click="loginBack" v-if="isLoggedAs">
        <v-list-item-action>
          <v-icon>transfer_within_a_station</v-icon>
        </v-list-item-action>
        <v-list-item-content>{{ $t("global.menu.loginBack") }}</v-list-item-content>
      </v-list-item>
    </template>
    <template v-else>
      <v-list-item to="/login">
        <v-list-item-action>
          <v-icon>exit_to_app</v-icon>
        </v-list-item-action>
        <v-list-item-content>{{ $t("global.logIn") }}</v-list-item-content>
      </v-list-item>
    </template>
  </div>
</template>

<script>
export default {
  name: "MainMenuStandalone",
  data() {
    return {
      right: null,
      mini: true,
      drawer: true,
      hover: null,
      name: null,
      nameRules: null
    };
  },
  computed: {
    isLoggedAs() {
      return this.$store.getters.userProperties != null && typeof this.$store.getters.userProperties.context_user_login !== "undefined";
    },
    // can_user_login_as_menu: function () {
    //     if ((typeof (this.$store.getters.userProperties) !== 'undefined') && (this.$store.getters.userProperties != null)) {
    //         return this.$store.getters.userProperties.can_login_as;
    //     }
    //     return false;
    // },
    countCanLoginAs() {
      if (this.$store.getters.userProperties != null) {
        return this.$store.getters.userProperties.substitute_user_count;
      }
      return null;
    },
    hasPermissionForInvoices() {
      return (
        this.$store.getters.hasPermission("viewInvoices") ||
        this.$store.getters.hasPermission("companyAdmin") ||
        this.$store.getters.hasPermission("SuperAdmin")
      );
    },
    hasPermissionForBookings() {
      return (
        (this.$store.getters["userProperties"].system_settings.is_module_all_bookings_enabled === 2 ||
          this.$store.getters["userProperties"].system_settings.is_module_flight_bookings_enabled === 2) &&
        (this.$store.getters.hasPermission("bookingMapping") ||
          this.$store.getters.hasPermission("viewBookingAssigned") ||
          this.$store.getters.hasPermission("viewAllBookings") ||
          this.$store.getters.hasPermission("companyAdmin") ||
          this.$store.getters.hasPermission("SuperAdmin"))
      );
    },
    hasPermissionForAdmin() {
      return this.$store.getters.hasPermission("companyAdmin");
    }
  },
  methods: {
    showFullMenu: function() {
      this.mini = false;
    },
    hideFullMenu: function() {
      this.mini = true;
    },
    is_user_logged: function() {
      return this.$store.getters.isAuthenticated;
    },
    loginBack: function() {
      this.$store.dispatch("AUTH_LOGIN_BACK").then(() => {
        this.$router.push("/substitutes");
      });
    }
  }
};
</script>

<style>
.menu-badge span {
  font-size: small;
  font-weight: bold;
  height: 18px;
  width: 18px;
  padding-top: 2px;
}
</style>

<style scoped>
.v-list-item {
  justify-content: left !important;
}
</style>
